import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { Switch, Breadcrumbs, FormControlLabel, TextField, Radio, RadioGroup, FormControl } from '@mui/material';
import { company_name, GetSchema, company_tel, company_country, string_required } from '../../../js/Base/ValidationSchema';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { InputField } from '../../../components/Common/FormikField/InputField';
import { Formik, Form, Field } from 'formik';
import toastAlert from '../../../js/Base/ToastAlert';
import { GreenSwitch } from '../../../components/Common/GreenSwitch';
import TimezoneSelect from "react-timezone-select";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { updateCompany } from '../../../api/companyApi';

export default function CompanyBaseInfoCard({ company }) {
    const [loading, setLoading] = useState(true);
    const [mfaActive, setMfaActive] = useState(company?.enable_mfa || false);
    const formInitialValues = {
      name: company?.name || "",
      eng_name: company?.eng_name || "",
      country: company?.country || "",
      address: company?.address || "",
      tel: company?.tel || "",
      company_owner: company?.company_owner || "",
      timezone: company?.timezone || "",
      report_logo_pic: company?.report_logo_pic || "",
    };

  const handleSwitchChange = (e) => {
    setMfaActive(e.target.checked);
    if(e.target.checked) {
      toastAlert.autoClose(true).showInfo("請確認ConfigKey中的EMAIL資訊")
    }
    // setInitialValues((prev) => ({
    //   ...prev,
    //   enable_mfa: e.target.checked,
    // }));
  };

  const formSchema = GetSchema({
    name: company_name(),
    country: company_country(),
    address: string_required(),
    tel: company_tel(),
    company_owner: string_required(),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const companyUuid = localStorage.getItem("company_uuid");
      const companyData = { 
        ...values, 
        company_uuid: companyUuid, 
        enable_mfa: mfaActive 
      };

      const response = await updateCompany(companyData);
      const data = response.data;
      if (data.success) {
        toastAlert.autoClose(true).showSuccess("公司資料已更新");
      } else {
        toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    } finally {
      setSubmitting(false);
    }
  };

  const titleStyle = {
    fontSize: '12px',
    color: '#323232',
    fontWeight: 'bold',
    marginTop: '20px',
    marginBottom: '6px',
    fontFamily: 'Noto Sans, sans-serif'
  };

  const checkbox_style = {
    borderColor: '#7FBE25',
    borderWidth: '1px',
    width: '20px',
    height: '20px',
    fontSize: '10px',
    color: '#323232',
  };

  return (
    <Card style={{ marginBottom: '20px'}}>
      <Card.Header style={{ backgroundColor: 'transparent' }}>
        <strong style={{ fontSize:'16px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>基本資料</strong>
      </Card.Header>
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={formSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <Card.Body style={{ paddingTop: '5px' }}>
              <Row >
                <Col md={6}>
                  <InputFormFiled
                    title="公司名稱"
                    className="input-field custom-select"
                    name="name"
                    type="text"
                    invalid={errors.name && touched.name}
                    value
                  />
                </Col>
                <Col md={6}>
                  <InputFormFiled
                    title="公司名稱(英文)"
                    className="input-field custom-select"
                    name="eng_name"
                    type="text"
                  />
                </Col>
                <Col md={6}>
                  <InputFormFiled
                    title="公司國家"
                    className="input-field custom-select"
                    name="country"
                    type="text"
                    invalid={errors.country && touched.country}
                  />
                </Col>
                <Col md={6}>
                  <InputFormFiled
                    title="公司地址"
                    className="input-field custom-select"
                    name="address"
                    type="text"
                    invalid={errors.address && touched.address}
                  />
                </Col>
                <Col md={6}>
                  <InputFormFiled
                    title="公司電話"
                    className="input-field custom-select"
                    name="tel"
                    type="text"
                    invalid={errors.tel && touched.tel}
                  />
                </Col>
                <Col md={6}>
                  <InputFormFiled
                    title="公司負責人"
                    className="input-field custom-select"
                    name="company_owner"
                    type="text"
                    invalid={errors.company_owner && touched.company_owner}
                  />
                </Col>
                <Col md={6}>
                  <p style={titleStyle}>公司使用時區</p>
                  <Field name="timezone">
                      {({ field, form }) => (
                        <TimezoneSelect
                          value={field.value || ""}
                          onChange={(tz) => form.setFieldValue("timezone", tz.value)}
                        />
                      )}
                    </Field>
                </Col>
                <Col md={6} />
                <Col md={6}>
                  <p style={titleStyle}>報表Logo</p>
                  <Field name="report_logo_pic">
                  {({ field, form }) => (
                    <RadioGroup
                      row
                      value={field.value}
                      onChange={(e) => form.setFieldValue("report_logo_pic", e.target.value)}
                      name="report_logo_pic"
                    >
                      <FormControlLabel
                        value="eDC"
                        control={
                          <Radio
                            sx={{
                              color: '#7fbe25',
                              '&.Mui-checked': {
                                color: '#7fbe25',
                              },
                            }}
                          />
                        }
                        label="eDC"
                      />

                      <FormControlLabel
                        value="ACSI"
                        control={
                          <Radio
                            sx={{
                              color: '#7fbe25',
                              '&.Mui-checked': {
                                color: '#7fbe25',
                              },
                            }}
                          />
                        }
                        label="ACSI"
                      />
                    </RadioGroup>
                  )}
                  </Field>
                </Col>
                <Col md={6}>
                  <p style={titleStyle}>雙重驗證</p>
                  <FormControlLabel
                    checked={mfaActive}
                    onChange={(e) => handleSwitchChange(e)}
                    control={<GreenSwitch />}
                    label="啟用"
                    labelPlacement="start"
                    sx={{
                      ml: 0,
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                        fontFamily: 'Noto Sans, sans-serif'
                      }
                    }}
                  />
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '50px',
                paddingBottom: '28px',
                paddingRight: '26px',
                paddingTop: '20px',
                backgroundColor: 'transparent',
                height: '85px',
              }}
              className="CompanyManagement"
            >
              <Button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-custom"
              >
                儲存
              </Button>
            </Card.Footer>
          </Form>
        )}
      </Formik>
    </Card>
  );
}
